import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
} from "recharts";
import { motion } from "framer-motion";

const TooltipContent = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;
  const value = payload[0]?.value;
  return (
    <div className="rounded-md border border-slate-200 bg-white px-3 py-2 text-xs text-slate-600 shadow">
      <p className="text-xs font-semibold text-slate-700">{label}</p>
      <p className="mt-1">{value}</p>
    </div>
  );
};

export default function ChartWidget({
  title,
  subtitle,
  config,
  data,
  onHover,
}) {
  return (
    <motion.div
      className="card p-4"
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <p className="text-sm font-semibold text-slate-900">{title}</p>
      <p className="mt-1 text-xs text-slate-500">{subtitle}</p>
      <div className="mt-4 h-56 w-full">
        <ResponsiveContainer>
          {config.type === "pie" ? (
            <PieChart onMouseMove={onHover}>
              <Pie
                data={data}
                dataKey={config.valueKey}
                nameKey={config.nameKey}
                outerRadius={80}
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`${entry.name}-${index}`}
                    fill={config.colors?.[index % config.colors.length]}
                  />
                ))}
              </Pie>
              <Tooltip content={<TooltipContent />} />
            </PieChart>
          ) : (
            <BarChart data={data} onMouseMove={onHover}>
              <XAxis
                dataKey={config.nameKey}
                tickLine={false}
                axisLine={false}
                fontSize={10}
              />
              <YAxis tickLine={false} axisLine={false} fontSize={10} />
              <Tooltip content={<TooltipContent />} />
              <Bar dataKey={config.valueKey} fill="#f59e0b" radius={[6, 6, 0, 0]} />
            </BarChart>
          )}
        </ResponsiveContainer>
      </div>
    </motion.div>
  );
}
